/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';

interface HiddenActionTextProps {
  value: string;
  alwaysShow: boolean;
  onClick: () => void;
}

const HiddenActionText: React.FC<HiddenActionTextProps> = ({ value, alwaysShow, onClick }) => {

  const handleClick = () => {
    onClick();
  };

  const className = 'hidden-field' + (alwaysShow ? ' shown' : '');
  return (
    <span className={className}>
      <label onClick={handleClick} id={'hidden-action-' + value.replace(/ /g, '-').toLowerCase()}>
        {value}
      </label>
    </span>
  );
};

export default HiddenActionText;
